import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import ChevronRight from 'icons/src/ChevronRight';

import Section from '../components/section';
import { Check } from '../components/icons';

const Title = styled.h2`
  margin-bottom: 30px;
`;
const CardListGrid = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: ${(props) => props.theme.grid.columnGap};
  grid-template-columns: 1fr 1rem;
  align-items: center;
  padding: 1rem;
`;
const CardList = styled.article`
  background-color: white;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.11);
  border-radius: .25rem;
  margin-bottom: 1rem;

  &:hover {
    background-color: ${({ theme }) => theme.grayLightColor};
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  h2 {
    margin: 0;
    color: ${({ theme }) => theme.primaryColor};
    font-size: 1.333rem;
    margin-bottom: .5rem;
  }
  h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 300;
    color: inherit;
  }
  svg {
    width: 1rem;
    color: #cbcdcd;
  }
`;
const CheckList = styled.ul`
  margin: 0;
  padding: 0;
  li {
    list-style: none;
    position: relative;
    padding: 8px 0 8px 2rem;
    line-height: 160%;
    a,
    span {
      color: inherit;
      text-decoration: none;
    }
    svg {
      position: absolute;
      top: 1.1rem;
      left: 0;
      transform: translateY(-50%);
      width: 1.222rem;
      color: ${({ theme }) => theme.primaryColor};
    }
  }
`;

const List = ({
  rowOptions,
  title,
  items,
  variant,
  className,
}) => (
  <Section
    className={className}
    id={rowOptions?.sectionId || ''}
    backgroundColor={rowOptions?.backgroundColor}
    hideBottomSpacing={rowOptions?.hideBottomSpacing}
    hideTopSpacing={rowOptions?.hideTopSpacing}
    hideRow={rowOptions?.hideRow}
  >
    <Container small>
      <Title>{title}</Title>
      {((variant === 'check_list') || !variant) && (
        <CheckList>
          {items.map(({ id, title: t, link }) => {
            const Comp = link ? Link : 'span';
            return (
              <li key={id}>
                <Comp to={link}>
                  <Check />{t}
                </Comp>
              </li>
            );
          })}
        </CheckList>
      )}
      {(variant === 'card_list') && items.map(({
        id,
        title: t,
        subtitle,
        link,
      }) => {
            const Comp = link ? Link : 'span';
            return (
              <CardList key={id}>
                <Comp to={link}>
                  <CardListGrid>
                    <div>
                      <h2>{t}</h2>
                      <h3>{subtitle}</h3>
                    </div>
                    <ChevronRight />
                  </CardListGrid>
                </Comp>
              </CardList>
            );
          })}
    </Container>
  </Section>
);

export default styled(List)``;
